import { UUID } from '@hc-frontend/core-types';
import { z } from 'zod';

const TypeCampaign = {
  featuredAds: 1,
  featuredPlan: 2,
} as const;

const PlanDTO = z.object({
  AdvertiserID: z.number(),
  RightRail: z.string().nullable(),
  AdsID: UUID,
  IdCampaign: z.number(),
  DealType: z.enum(['CPC', 'CPA']),
  CampaignName: z.string(),
  Carriers: z.array(z.number()).nullable(),
  TypeCampaign: z.nativeEnum(TypeCampaign),
  AdGroupId: z.number(),
  AdGroupWeight: z.number(),
  RingPoolId: z.string(),
  AgeRange: z.array(z.number()).nullable(),
  MetalLevel: z.string().nullable(),
  PlanType: z.null(),
  Rating: z.null(),
  RxIncluded: z.null(),
  Brand: z.string(),
  ActualRange: z.string(),
  IRRevenueShare: z.string(),
  AdvertiserName: z.string(),
  Exclusion: z.string(),
  Discounts: z.string(),
  SubsidyAvailability: z.string().nullable(),
  OldPrice: z.string().nullable(),
  NewPrice: z.string(),
  BidProcessPrice: z.string().nullable(),
  Budget: z.string(),
  BidProcessDate: z.null(),
  BrandMessage: z.string().nullable(),
  AdCreative: z.object({
    Id: z.number(),
    Name: z.string(),
    Snippet: z.string(),
    Image: z.string(),
    Title: z.string(),
    DisplayUrl: z.string(),
  }),
  Delivery: z.object({
    Phone: z.object({
      Enabled: z.boolean(),
      Url: z.string().nullable(),
      Price: z.number(),
    }),
    Click: z.object({
      Enabled: z.boolean(),
      Url: z.string().nullable(),
      InterstitialUrl: z.string().nullable(),
      Price: z.number(),
    }),
    Email: z.object({
      Enabled: z.boolean(),
      Url: z.string().nullable(),
      InterstitialUrl: z.string().nullable(),
      Price: z.number(),
    }),
  }),
});

export type PlanDTO = z.infer<typeof PlanDTO>;

export const FeaturedAdDto = z.object({
  Id: UUID,
  SearchMethod: z.string(),
  SegmentationFit: z.string(),
  ModelProductFit: z.string(),
  Result: z.array(PlanDTO),
});

export type FeaturedAdDto = z.infer<typeof FeaturedAdDto>;
